// SPDX-License-Identifier: AGPL-3.0-or-later

import type {ThemeVariableName} from '@app/features/theme/variables/ThemeVariableManifest';

export const SKELETON_SURFACE_TOKENS = [
	'--active-now-action-gap',
	'--active-now-action-height',
	'--active-now-action-padding-block',
	'--active-now-action-padding-inline',
	'--active-now-action-radius',
	'--active-now-card-gap',
	'--active-now-card-padding-block',
	'--active-now-card-padding-inline',
	'--active-now-card-radius',
	'--active-now-card-shadow',
	'--active-now-context-gap',
	'--active-now-sidebar-content-gap',
	'--active-now-sidebar-content-padding-block-end',
	'--active-now-sidebar-content-padding-inline',
	'--active-now-sidebar-header-padding-block-end',
	'--active-now-sidebar-header-padding-block-start',
	'--active-now-sidebar-header-padding-inline',
	'--active-now-sidebar-width',
	'--avatar-stack-extra-height',
	'--background-header-secondary',
	'--background-modifier-accent',
	'--background-modifier-hover',
	'--background-modifier-selected',
	'--background-primary',
	'--background-secondary',
	'--background-secondary-alt',
	'--background-secondary-lighter',
	'--background-textarea',
	'--brand-primary',
	'--channel-header-action-icon-size',
	'--channel-header-action-size',
	'--channel-header-action-size-mobile',
	'--channel-header-actions-gap',
	'--channel-header-back-button-gap',
	'--channel-header-back-button-size',
	'--channel-header-back-icon-size',
	'--channel-header-caret-gap',
	'--channel-header-caret-size',
	'--channel-header-gap',
	'--channel-header-icon-size',
	'--channel-header-name-gap',
	'--channel-header-name-gap-group-dm',
	'--channel-header-padding-inline',
	'--channel-header-topic-divider-gap',
	'--chat-horizontal-padding',
	'--chat-horizontal-padding-default',
	'--chat-mobile-horizontal-padding',
	'--composer-surface-color',
	'--count-indicator-gap',
	'--discovery-card-description-min-height',
	'--dm-sidebar-mobile-header-height',
	'--floating-surface-ring-color',
	'--floating-surface-ring-color-strong',
	'--folder-radius',
	'--font-size',
	'--footer-box-inset',
	'--footer-box-inset-inline',
	'--footer-box-radius',
	'--form-surface-background',
	'--friend-row-action-gap',
	'--friend-row-content-gap',
	'--friend-row-name-line-height',
	'--friend-row-padding-block',
	'--friend-row-padding-inline',
	'--friend-row-separator-inset',
	'--friend-row-separator-radius',
	'--friend-row-subtext-line-height',
	'--friend-row-subtext-offset',
	'--guild-badge-surface',
	'--guild-folder-expanded-surface-size',
	'--guild-icon-size',
	'--guild-list-divider-base-gap',
	'--guild-list-divider-line-size',
	'--guild-list-indicator-bar-width',
	'--guild-list-indicator-inset',
	'--guild-list-indicator-track-width',
	'--guild-list-item-box-size',
	'--guild-list-item-gap',
	'--guild-list-item-target-half-extra',
	'--guild-list-item-target-size',
	'--guild-members-columns',
	'--guild-members-columns-selectable',
	'--guild-members-min-width',
	'--guild-members-min-width-selectable',
	'--guild-members-table-row-border-width',
	'--guild-members-table-row-min-height',
	'--guilds-layout-item-bg',
	'--input-container-padding',
	'--layout-guild-list-width',
	'--layout-header-height',
	'--layout-header-height-mobile',
	'--layout-member-list-width',
	'--layout-mobile-bottom-nav-reserved-height',
	'--layout-sidebar-width',
	'--layout-user-area-height',
	'--layout-user-area-reserved-height',
	'--layout-voice-connection-height',
	'--member-list-group-spacer-height',
	'--member-list-item-content-gap',
	'--member-list-item-name-line-height',
	'--member-list-item-padding-block',
	'--member-list-item-padding-inline',
	'--member-list-item-status-line-height',
	'--member-list-row-gap',
	'--member-list-scroller-padding-block-end',
	'--member-list-scroller-padding-block-start',
	'--member-list-scroller-padding-inline',
	'--mention-badge-small-size',
	'--message-action-bar-offset',
	'--message-avatar-align-offset',
	'--message-avatar-size',
	'--message-avatar-size-compact',
	'--message-compact-gap',
	'--message-compact-horizontal-padding',
	'--message-compact-text-indent-from-username',
	'--message-compact-timestamp-width',
	'--message-compact-username-gap',
	'--message-gutter',
	'--message-line-height',
	'--message-mobile-margin',
	'--message-search-bar-height',
	'--message-search-bar-icon-gap',
	'--message-search-bar-icon-size',
	'--message-search-bar-width',
	'--message-spacing-y',
	'--messages-bottom-clearance',
	'--mobile-bottom-nav-height',
	'--native-titlebar-height',
	'--outline-frame-border-width',
	'--outline-frame-radius-native',
	'--panel-control-bg',
	'--radius-full',
	'--radius-lg',
	'--radius-md',
	'--radius-sm',
	'--radius-xl',
	'--skeleton-chrome-border',
	'--skeleton-opacity-default',
	'--skeleton-opacity-muted',
	'--skeleton-opacity-strong',
	'--spacing-1',
	'--spacing-10',
	'--spacing-2',
	'--spacing-3',
	'--spacing-4',
	'--spacing-5',
	'--spacing-6',
	'--spacing-8',
	'--text-primary',
	'--text-primary-muted',
	'--textarea-button-height',
	'--textarea-button-icon-size',
	'--theme-border-width',
	'--user-area-avatar-lead',
	'--user-area-box-inset-block-end',
	'--user-area-content-height',
	'--user-area-divider-color',
	'--user-area-padding-x',
	'--user-area-padding-y',
	'--z-index-elevated-1',
	'--z-index-modal',
] as const satisfies ReadonlyArray<ThemeVariableName>;

export type SkeletonSurfaceToken = (typeof SKELETON_SURFACE_TOKENS)[number];

export const SKELETON_SCOPED_TOKENS = [
	'--layout-user-area-overlay-height',
	'--outline-radius',
	'--skeleton-shimmer-delay',
] as const;

export type SkeletonScopedToken = (typeof SKELETON_SCOPED_TOKENS)[number];

export const SKELETON_INJECTED_TOKENS = [
	'--active-now-participant-outline',
	'--active-now-participant-overlap',
	'--active-now-participant-size',
	'--chat-horizontal-padding',
	'--discovery-card-max-width',
	'--discovery-card-min-width',
	'--discovery-grid-gap',
	'--font-size',
	'--member-list-group-header-height',
	'--member-list-item-height',
	'--member-list-item-height-group-dm',
	'--message-compact-timestamp-width',
	'--message-group-spacing',
] as const;

export type SkeletonInjectedToken = (typeof SKELETON_INJECTED_TOKENS)[number];

export function skeletonSurfaceVar(token: SkeletonSurfaceToken): `var(${SkeletonSurfaceToken})` {
	return `var(${token})`;
}
